import { gql } from "@apollo/client";
import { useNorthbeamMutation, useNorthbeamQuery } from "@hooks/http";
import {
  type ColumnOrdering as ColumnOrderingQuery,
  type ColumnOrderingVariables as ColumnOrderingQueryVariables,
  type SetColumnOrdering,
  type SetColumnOrderingVariables,
} from "@north-beam/nb-client-side";

export const COLUMN_ORDERING_STRING_FOR_SALES_PAGE_PRIMARY_TABLE =
  "NorthbeamSalesPagePrimaryTable";

export const useColumnOrdering = () => {
  const { data, loading: columnOrderingLoading } = useNorthbeamQuery<
    ColumnOrderingQuery,
    ColumnOrderingQueryVariables
  >(COLUMN_ORDERING_QUERY, {
    variables: {
      tableName: COLUMN_ORDERING_STRING_FOR_SALES_PAGE_PRIMARY_TABLE,
    },
  });

  const [setColumnOrdering] = useNorthbeamMutation<
    SetColumnOrdering,
    SetColumnOrderingVariables
  >(SET_COLUMN_ORDERING, {
    refetchQueries: [
      {
        query: COLUMN_ORDERING_QUERY,
        variables: {
          tableName: COLUMN_ORDERING_STRING_FOR_SALES_PAGE_PRIMARY_TABLE,
        },
      },
    ],
  });

  return {
    columnOrdering: data?.me?.columnOrdering || [],
    columnOrderingLoading,
    setColumnOrdering,
  };
};

const HACK_COLUMNS_TO_MATCH = [
  "Attributed Rev",
  "ROAS",
  "ECR",
  "CAC",
  "Txns",
  "Email Signups",
  "Email Signup Rate",
  "Cost per Email Signup",
];

export const HACK_columnMatching = (
  columnKey: string,
  columnKey2?: string,
): boolean => {
  const matchedNameIndex = HACK_COLUMNS_TO_MATCH.findIndex(
    (name) => columnKey.startsWith(name) && columnKey2?.startsWith(name),
  );
  const isMatching = matchedNameIndex !== -1;
  // To ignore the attribution window in the column name
  if (
    columnKey.endsWith("accrual") &&
    columnKey2?.endsWith("accrual") &&
    // infinity is forecasted so we don't want to rename it
    !columnKey.includes("infinity") &&
    !columnKey2?.includes("infinity") &&
    isMatching
  ) {
    return true;
  }

  return columnKey === columnKey2;
};

export const COLUMN_ORDERING_QUERY = gql`
  query ColumnOrdering($tableName: String!) {
    me {
      id
      columnOrdering(tableName: $tableName)
    }
  }
`;

export const SET_COLUMN_ORDERING = gql`
  mutation SetColumnOrdering($columnOrdering: [String!]!, $tableName: String!) {
    setColumnOrdering(columnOrdering: $columnOrdering, tableName: $tableName)
  }
`;
